export const ImageProcessingEngineVersion = 13;
export const DoSmallDetailsPart = true;
